import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveAttributeAnswer } from '../../projectDetailsActivities.models';
import { RenderRelatedAnnotationsCount } from './RenderRelatedAnnotationsCount2';

export const RemoveAttributeAnswerActivity = ({ values }: IProjectActivity<IProjectActivityRemoveAttributeAnswer>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_common.removeAnswer')}
      <b>{values.answer}</b> {t('activity_description_common.from')} {t('activity_description_common.attribute')} <b>{values.attribute}</b>
      <RenderRelatedAnnotationsCount
        strategy={values.strategy}
        count={values.updatedAnnotationsCount}
      />
      .
    </span>
  );
};
